import React from "react";
import GridContainer from "components/UI/Grid/GridContainer";
import GridItemTS from "components/UI/Grid/GridItemTS";
import { TabContent, TabSystem } from "components/UI/TabSystem";
import EquipmentsCreate from "./EquipmentsCreate/EquipmentsCreate";
import Workers from "views/List/Workers";
import useHasRole from "hooks/useHasRole";
import { RolesEnum } from "utils/@types";
import { ProfileTab } from "enums/ProfileTabs";
import { useTranslation } from "react-i18next";

const Equipments: React.FC = () => {
  const { hasResourceRole } = useHasRole();
  const { t } = useTranslation("worker-profile");
  const canSeeTab2 = hasResourceRole([RolesEnum.SUPPLIER]);

  const tabs = [
    {
      id: ProfileTab.EQUIPMENTS_LIST,
      title: t(ProfileTab.EQUIPMENTS_LIST),
    },
    {
      id: ProfileTab.NEW_EQUIPMENTS,
      title: t(ProfileTab.NEW_EQUIPMENTS),
      visible: canSeeTab2,
    },
  ].filter((tab) => (tab.visible !== undefined ? tab.visible : true));

  return (
    <GridContainer>
      <GridItemTS xs={12} style={{ marginTop: "1rem" }}>
        <TabSystem tabs={tabs} syncWithUrlParams>
          <TabContent value={ProfileTab.EQUIPMENTS_LIST}>
            <GridContainer>
              <GridItemTS key="user-list-data" xs={12}>
                <Workers />
              </GridItemTS>
            </GridContainer>
          </TabContent>
          <TabContent value={ProfileTab.NEW_EQUIPMENTS}>
            <EquipmentsCreate />
          </TabContent>
        </TabSystem>
      </GridItemTS>
    </GridContainer>
  );
};

export default Equipments;
